import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import {
  AdminListRequestOfBaseFilter,
  Attribute,
  ListResponseOfLocationType,
} from "services/KnowfullyAdminClient";
import { AttributeMetaValues } from "types/common-types";

export function LocationTypeColumnView({ value }: { value: Attribute }) {
  const { locationTypeService } = useGlobalContext();

  const storedId = value.attributeMetaValues?.find(
    (m) => m.name === AttributeMetaValues.LocationTypeId,
  )?.value;

  const { data } = useQuery<ListResponseOfLocationType>(
    ["locationTypeService.getLocationTypes"],
    () =>
      locationTypeService.getLocationTypes(
        AdminListRequestOfBaseFilter.fromJS({ sortField: "name" }),
      ),
  );

  if (!storedId) return null;

  const item = data?.data?.find(
    (d: { id?: string }) =>
      String(d.id ?? "").toLowerCase() === String(storedId).toLowerCase(),
  );
  return <>{item?.name ?? ""}</>;
}
